
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/acceptcredit/contact-us",
      function () {
        return require("private-next-pages/acceptcredit/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/acceptcredit/contact-us"])
      });
    }
  